"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const useMergeRefs_1 = __importDefault(require("../../../hooks/useMergeRefs"));
const usePrevious_1 = __importDefault(require("../../../hooks/usePrevious"));
require("./TabsContext.scss");
const TabsContext = (0, react_1.forwardRef)(({ className, id, activeTabId = 0, children }, ref) => {
    const componentRef = (0, react_1.useRef)(null);
    const mergedRef = (0, useMergeRefs_1.default)({ refs: [ref, componentRef] });
    const [previousActiveTabIdState, setPreviousActiveTabIdState] = (0, react_1.useState)(activeTabId);
    const [activeTabIdState, setActiveTabIdState] = (0, react_1.useState)(activeTabId);
    const prevActiveTabIdProp = (0, usePrevious_1.default)(activeTabId);
    (0, react_1.useEffect)(() => {
        // Update active tab if changed from props
        if (activeTabId !== prevActiveTabIdProp && activeTabId !== activeTabIdState) {
            setPreviousActiveTabIdState(activeTabIdState);
            setActiveTabIdState(activeTabId);
        }
    }, [activeTabId, prevActiveTabIdProp, activeTabIdState, setPreviousActiveTabIdState, setActiveTabIdState]);
    const onTabClick = (0, react_1.useCallback)((tabId) => {
        setPreviousActiveTabIdState(activeTabIdState);
        setActiveTabIdState(tabId);
    }, [setPreviousActiveTabIdState, activeTabIdState, setActiveTabIdState]);
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({ ref: mergedRef, className: (0, classnames_1.default)("tabs-context--wrapper", className), id: id }, { children: react_1.default.Children.map(children, child => {
            // @ts-ignore
            if (child.type.isTabList) {
                return react_1.default.cloneElement(child, { activeTabId: activeTabIdState, onTabChange: onTabClick });
            }
            // @ts-ignore
            if (child.type.isTabPanels) {
                const animationDirection = previousActiveTabIdState < activeTabIdState ? "ltr" : "rtl";
                return react_1.default.cloneElement(child, { activeTabId: activeTabIdState, animationDirection });
            }
            return child;
        }) })));
});
exports.default = TabsContext;
